import { render, staticRenderFns } from "./addnew.vue?vue&type=template&id=0761f926&scoped=true"
import script from "./addnew.vue?vue&type=script&lang=js"
export * from "./addnew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761f926",
  null
  
)

export default component.exports